<template>
  <div>
    <div class="animated fadeIn">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"
      />
    </div>

    <b-col cols="12">
      <transition name="slide">
        <b-card header="Lista de produtos cadastrados">
          <b-row>
            <b-col cols="4">
              <b-form-group label="Filtros" label-class="font-weight-bold pt-0">
                <b-form-select
                  id="formSelect"
                  :options="optionsFilter"
                  v-model="selectedFilter"
                  @change="focus('filterInput')"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col cols="4">
              <b-form-group>
                <b-form-checkbox
                  size="md"
                  id="checkbox-1"
                  v-model="highlight"
                  name="cbDestacados"
                  value="true"
                  unchecked-value="false"
                  @change="getProducts(1)"
                  style="font-weight: bold"
                >
                  <i> Somente produtos destacados </i>
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col xl="6" lg="6" md="12" sm="12">
              <b-form-group>
                <b-input-group size="md" prepend="Produto">
                  <b-form-input
                    type="search"
                    id="filterInput"
                    placeholder="Digite para pesquisar"
                    v-model="product"
                    @keyup.enter="getProducts(1)"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button :disabled="!product" @click="cleanSearch()"
                      >Limpar</b-button
                    >
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>

            <Pagination :source="pagination" @navigate="navigate"></Pagination>

            <!--             <div class="overflow-auto">
              <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                first-text="Primeiro"
                prev-text="Anterior"
                next-text="Próximo"
                last-text="Último"
              >
              </b-pagination>
            </div> -->
          </b-row>

          <b-table
            id="tableItens"
            hover
            striped
            bordered
            responsive
            stickyColumn
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            @row-clicked="abrirModal"
            head-variant="light"
          >
            <template #thead-top>
              <b-tr>
                <b-th colspan="1">Destaque</b-th>
                <b-th colspan="2">Ativo</b-th>
                <b-th colspan="5">Dados do Item</b-th>
                <b-th colspan="2">Valores</b-th>
                <b-th colspan="3">Subdivisões</b-th>
                <b-th colspan="3">Permissões</b-th>
              </b-tr>
            </template>

            <template v-slot:cell(foto)="data">
              <img
                v-if="data.item.foto"
                width="50"
                height="50"
                class="center-image"
                text-align="center"
                :src="data.item.foto"
                alt="Thumbnail"
              />
            </template>

            <template v-slot:cell(ativo)="data">
              <b-badge v-if="data.item.ativo == false" variant="danger">
                {{ data.item.ativo == false ? "Não" : "Sim" }}
              </b-badge>
              <b-badge v-else variant="success">
                {{ data.item.ativo == false ? "Não" : "Sim" }}
              </b-badge>
            </template>

            <template v-slot:cell(observacoesCadastro)="data">
              <b-badge
                v-if="data.item.observacoesCadastro != ''"
                variant="danger"
              >
                {{ data.item.observacoesCadastro != "" ? "Não" : "Sim" }}
              </b-badge>
              <b-badge v-else variant="success">
                {{ data.item.observacoesCadastro != "" ? "Não" : "Sim" }}
              </b-badge>
            </template>

            <template v-slot:cell(permiteVendaSemEstoque)="data">
              <b-badge
                v-if="data.item.permiteVendaSemEstoque"
                variant="success"
              >
                {{ data.item.permiteVendaSemEstoque ? "Sim" : "Não" }}
              </b-badge>
              <b-badge v-else variant="danger">
                {{ data.item.permiteVendaSemEstoque ? "Sim" : "Não" }}
              </b-badge>
            </template>

            <template v-slot:cell(permiteObs)="data">
              <b-badge v-if="data.item.permiteObs" variant="success">
                {{ data.item.permiteObs ? "Sim" : "Não" }}
              </b-badge>
              <b-badge v-else variant="danger">
                {{ data.item.permiteObs ? "Sim" : "Não" }}
              </b-badge>
            </template>

            <template v-slot:cell(descricaoSetor)="data">
              {{ data.item.setorId }} - {{ data.item.descricaoSetor }}
            </template>

            <template v-slot:cell(descricaoGrupo)="data">
              {{ data.item.grupoId }} - {{ data.item.descricaoGrupo }}
            </template>

            <template v-slot:cell(descricaoMarca)="data">
              {{ data.item.marcaId }} - {{ data.item.descricaoMarca }}
            </template>

            <template v-slot:cell(destaqueHomeApp)="data">
              <div class="fa-2x" style="text-align: center">
                <i v-if="data.item.destaqueHomeApp == 1" class="fa fa-star"></i>
                <i v-else class="fa fa-star-o"></i>
              </div>
            </template>
          </b-table>
        </b-card>
      </transition>
    </b-col>

    <b-modal
      id="modalObsCadastro"
      ref="modalObsCadastro"
      title="Dados do Item"
      size="lg"
      hide-footer
    >
      <b-row>
        <b-col>
          <div class="card" style="width: 100%">
            <b-card
              bg-variant="dark"
              text-variant="white"
              title="Foto"
              class="text-center"
              style="height: 60px"
            ></b-card>
            <img :src="foto" class="card-img-top" />
          </div>
          <div>
            <b-card
              v-if="observacoesCadastro && observacoesCadastro.length > 1"
              bg-variant="dark"
              text-variant="white"
              title="Observações"
              class="text-center"
              style="height: 60px"
            ></b-card>
            <ul v-for="(obs, index) in observacoesCadastro" :key="index">
              <li v-if="obs" class="card-text">
                {{ obs }}
              </li>
            </ul>
          </div>
        </b-col>
        <b-col>
          <div class="card" style="width: 100%">
            <b-card
              bg-variant="dark"
              text-variant="white"
              title="Ações"
              class="text-center"
              style="height: 60px"
            ></b-card>
            <b-col cols="12" class="centerModal" @click="destacarProduto()">
              <i
                v-if="produtoDestacado"
                class="fa fa-star fa-custom-size"
                aria-hidden="true"
              ></i>
              <i
                v-if="!produtoDestacado"
                class="fa fa-star-o fa-custom-size"
                aria-hidden="true"
              ></i>
              <span v-if="produtoDestacado">
                Remover
                <br />destaque
              </span>
              <span v-if="!produtoDestacado">
                Destacar
                <br />produto
              </span>
            </b-col>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-button
          variant="danger"
          class="mt-3"
          block
          @click="$bvModal.hide('modalObsCadastro')"
        >
          <i class="fa fa-times-circle"></i>
          Fechar
        </b-button>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import axios from "axios";
import * as config from "@/config.json";
import { cnpjFormatter } from "../../assets/views/functions";

import Pagination from "../../assets/components/pagination.vue";
import ImageItem from "../banner/ImageItem.vue";

export default {
  name: "ProdutosCadastrados",
  components: { Loading, Pagination, ImageItem },
  data: () => {
    return {
      pagination: {},
      items: [],
      fields: [
        { key: "ativo", label: "Sistema" },
        { key: "observacoesCadastro", label: "App" },
        { key: "destaqueHomeApp", label: "Destaque" },
        { key: "foto", label: "Foto" },
        { key: "codBarras", label: "Barras" },
        { key: "descricao", label: "Descrição" },
        { key: "quantidade", label: "Qtde" },
        { key: "quantidadePorcao", label: "Porção" },
        { key: "venda", label: "Venda" },
        { key: "precoFidelizado", label: "Fidelizado" },
        { key: "descricaoSetor", label: "Setor" },
        { key: "descricaoGrupo", label: "Grupo" },
        { key: "descricaoMarca", label: "Marca" },
        { key: "permiteVendaSemEstoque", label: "Venda s/ Estoque" },
        { key: "permiteObs", label: "Obs" },
      ],
      currentPage: 1,
      perPage: 12,
      paginationRange: 11,
      totalRows: 0,
      isLoading: false,
      filterOn: [],
      cnpj: "",
      product: "",
      show: "Todos",
      observacoesCadastro: null,
      codBarras: null,
      urlRequest: "",
      index: null,
      foto: null,
      isDestaque: false,
      produtoDestacado: false,
      highlight: false,
      selectedFilter: null,
      optionsFilter: [
        { value: null, text: "Selecione uma opção de filtro" },
        { value: 1, text: "Barras" },
        { value: 2, text: "Descrição" },
      ],
    };
  },

  methods: {
    abrirModal(i) {
      this.foto = i.foto;
      this.observacoesCadastro = i.observacoesCadastro.split("\n");
      this.codBarras = i.codBarras;
      this.isDestaque = i.destaqueHomeApp;

      if (this.isDestaque == 1) {
        this.produtoDestacado = true;
      } else {
        this.produtoDestacado = false;
      }

      if (this.foto) {
        this.$refs.modalObsCadastro.show();
      } else {
        if (this.observacoesCadastro != "") {
          this.$refs.modalObsCadastro.show();
        }
      }
    },
    navigate(page) {
      this.getProducts(page);
    },

    focus(id) {
      document.getElementById(id).focus();
    },

    cleanSearch() {
      this.focus("filterInput");
      (this.product = ""), this.getProducts(this.page);
    },

    async destacarProduto() {
      this.isLoading = true;
      const url = `${config.default.urlBaseFdv}/product/${this.codBarras}/company/${this.cnpj}`;

      this.isDestaque = !this.isDestaque;

      try {
        const response = await axios({
          url,
          method: "put",
          data: {
            destaqueHomeApp: this.isDestaque,
          },
          headers: { authorization: config.default.authorizationToken },
        });

        if (response.status == 200) {
          this.isLoading = false;
          this.$refs.modalObsCadastro.hide();

          await this.$alert(
            `Destaque ${!this.isDestaque ? "removido" : "aplicado"}!`,
            "Sucesso",
            "success"
          );

          await this.getProducts();
        }
      } catch (error) {
        this.isLoading = false;
        await this.$alert(
          `Erro ao  ${this.isDestaque ? "remover" : "aplicar"} destaque!`,
          "Erro",
          "error"
        );
        console.log({ error });
      }
    },

    buildParams(cnpj, product, show, page, perPage, highlightOnly) {
      return {
        cnpj,
        product: this.selectedFilter == 2 ? product : null,
        barcode: this.selectedFilter == 1 ? product : null,
        show,
        page,
        pageSize: perPage,
        highlightOnly,
      };
    },

    async getProducts(pagina) {
      this.isLoading = true;
      this.cnpj = cnpjFormatter(localStorage.getItem("cnpj"));
      const url = `${config.default.urlBaseFdv}/product/search`;

      const params = this.buildParams(
        this.cnpj,
        this.product,
        this.show,
        pagina,
        this.perPage,
        this.highlight
      );

      try {
        const response = await axios({
          url: url,
          method: "get",
          params,
          headers: { authorization: `${config.default.authorizationToken}` },
        });

        if (response.status == 200) {
          this.pagination = response.data;
          this.pagination.rowsPerPage = this.perPage;
          this.pagination.paginationRange = this.paginationRange;

          this.items = response.data.items;
          this.totalRows = response.data.records;
          this.foto = response.data.foto;
          this.isDestaque = response.data.destaqueHomeApp;

          this.isLoading = false;

          if (response.data.records <= 0) {
            await this.$toasted.show("Nenhum registro encontrado!", {
              theme: "outline",
              position: "top-center",
              duration: 3000,
              icon: "warning",
              iconPack: "fontawesome",
            });
          }
        }
      } catch (error) {
        this.isLoading = false;
        await this.$toasted.show("Nenhum registro encontrado!", {
          theme: "outline",
          position: "top-center",
          duration: 3000,
          icon: "warning",
          iconPack: "fontawesome",
        });
        console.error({
          errorMessage: `[GetProducts] ${error}`,
        });
      }
    },
  },

  async beforeMount() {
    this.isLoading = true;
    await this.getProducts(1);
    this.isLoading = false;
  },

  computed: {
    rows() {
      return this.items.length;
    },
  },
};
</script>

<style>
.custom-control {
  position: relative;
  display: block;
  min-height: 1.3125rem;
  padding-left: 1.5rem;
  padding-top: 2rem;
}
</style>
